/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./OtherSources.vue?vue&type=template&id=59e07be6&scoped=true&"
import script from "./OtherSources.vue?vue&type=script&lang=js&"
export * from "./OtherSources.vue?vue&type=script&lang=js&"
import style0 from "./OtherSources.vue?vue&type=style&index=0&id=59e07be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e07be6",
  null
  
)

export default component.exports